import React, { useState, useEffect } from 'react'

import { Icon, ImageAdd, classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, func } from 'prop-types'

import { useImageSearch } from 'Pods/Shared/ImageSearch/Hooks/useImageSearch'

import { NOOP } from 'Utils/stableDefaults'

let ImageSearchDropdown

function ButtonIcon() {
  return <ImageAdd width="20" height="20" />
}

function ImageSearch({ locale = 'en', onActiveChange = NOOP }) {
  const [isDropdownLoaded, setIsDropdownLoaded] = useState(false)

  const {
    wrapperRef,
    triggerRef,
    isActive,
    isUploading,
    triggerImageSearch,
    handleFileDrop,
  } = useImageSearch({ onActiveChange })

  useEffect(() => {
    let isMounted = true

    if (isActive && !ImageSearchDropdown && !isDropdownLoaded) {
      loadDropdown(isMounted)
    }

    return () => {
      isMounted = false
    }
  }, [isActive, isDropdownLoaded])

  function loadDropdown(isMounted = true) {
    import('Pods/LazyLoaded/ImageSearchDropdown/ImageSearchDropdown')
      .then((module) => {
        if (isMounted) {
          ImageSearchDropdown = module.default
          setIsDropdownLoaded(true)
        }
      })
      .catch((error) => {
        if (window.Sentry) {
          window.Sentry.captureException(error)
        }
      })
  }

  function handlePreload() {
    if (!isDropdownLoaded && !ImageSearchDropdown) {
      loadDropdown()
    }
  }

  function handleKeyDown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      triggerImageSearch(event)
    }
  }

  return (
    <div
      className={classnames('unified-nav__image-search', isActive && 'unified-nav__image-search--active')}
      role="button"
      tabIndex={0}
      aria-label="Search by image"
      aria-haspopup="dialog"
      aria-expanded={isActive}
      onClick={triggerImageSearch}
      onKeyDown={handleKeyDown}
      onMouseEnter={handlePreload}
      onTouchStart={handlePreload}
      ref={triggerRef}
    >
      <Icon notSpaced color="dark" svgComponent={ButtonIcon} />
      {isActive && isDropdownLoaded && ImageSearchDropdown && (
        <div className="unified-nav__image-search-popover">
          <div className="unified-nav__image-search-popover-inner" ref={wrapperRef}>
            <ImageSearchDropdown
              isLoading={isUploading}
              handleFileDrop={handleFileDrop}
              locale={locale}
            />
          </div>
        </div>
      )}
    </div>
  )
}

ImageSearch.propTypes = {
  locale: string,
  onActiveChange: func,
}

export default ImageSearch
